import classNames from 'classnames'
import { useFormikContext } from 'formik'

import { ButtonArrow } from '../../../Button'
import { RecipientTag } from '../RecipientTag'
import { ShowContentButton } from '../ShowContentButton'

import * as styles from './EmailRecipientsCollapsed.module.css'

function EmailRecipientsCollapsed({
  Tag = RecipientTag,
  getFlattenRecipients,
  onClick,
}) {
  const { isSubmitting, values } = useFormikContext()

  const tagValue = getFlattenRecipients?.(values)[0]

  const containerClassName = classNames(styles.container, {
    [styles.disabled]: isSubmitting,
  })

  return (
    <div className={containerClassName}>
      <div className={styles.tagContainer}>
        {tagValue ? <Tag disabled={isSubmitting} item={tagValue} /> : null}
        <ShowContentButton onClick={onClick} />
      </div>
      <ButtonArrow />
    </div>
  )
}

export default EmailRecipientsCollapsed
